<aurora-checkbox
  class="{{ classes }}"
  [id]="labelFor"
  [label]="label"
  [checked]="isChecked"
  (change)="onCheckboxChange($event)"
></aurora-checkbox>